import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import ButtonBox from './ButtonBox.js';
import styles from './ButtonBoxCombined.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 *
 * - size
 *    - `large` | `medium` | `small` | `tiny`
 * - buttons
 *    - `TButtonBoxCombinedInnerButton[]`
 *    - 2개: [button, button]
 *    - 3개: [button, button, button]
 *    - 4개: [button, button, button, button]
 *
 */
function ButtonBoxCombined(_ref) {
  var size = _ref.size,
    variant = _ref.variant,
    color = _ref.color,
    buttons = _ref.buttons;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', variant)
  }, _mapInstanceProperty(buttons).call(buttons, function (button, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('cell'),
      key: index
    }, /*#__PURE__*/React.createElement(ButtonBox, _objectSpread({}, _objectSpread(_objectSpread({}, button), {}, {
      size: size,
      variant: variant,
      color: color,
      isWide: true
    }))));
  }));
}

export { ButtonBoxCombined as default };
